
import { getImageByPosition, setAttributeToElements } from "~/utils";

export default {
  name: "GridCard",
  props: {
    data: {
      type: Object,
      default: () => ({ path: "/product/conf" }),
    },
    contentPosition: {
      type: String,
      default: "center",
    },
    imageBrightnessFilter: {
      type: [String, Number],
      default: 100,
    },
  },
  computed: {
    itemImage() {
      const imageObj = getImageByPosition(this.data.medias, "list");
      return {
        url: imageObj?.file?.url || "",
        alt: imageObj?.alt || "",
      };
    },
  },
  mounted() {
    setAttributeToElements("a.hidden-ssr-link", "tabindex", "0");
  },
};
